import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Copy, RefreshCw } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

export default function SiteTab() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/site").then((r) => setS(r.data)); }, []);
  if (!s) return null;
  const link = `${window.location.origin}/?anteprima=${s.preview_code}`;
  const toggle = (v) => api.put("/admin/site", { maintenance: v }).then((r) => { setS(r.data); toast.success(v ? "Pagina 'In costruzione' attivata" : "Sito aperto al pubblico"); }).catch((e) => toast.error(errMsg(e)));
  const newCode = () => api.post("/admin/site/new-code").then((r) => { setS(r.data); toast.success("Nuovo link anteprima creato: il vecchio non funziona più"); });
  const copy = () => navigator.clipboard.writeText(link).then(() => toast.success("Link copiato"));
  return (
    <div className="grid gap-4 max-w-3xl" data-testid="site-tab">
      <div className="rounded-2xl border border-slate-200 bg-white p-5 sm:p-6 flex items-start justify-between gap-4">
        <div>
          <h3 className="font-display text-lg font-bold text-[#0B192C]">Pagina "In costruzione"</h3>
          <p className="mt-1 text-sm text-slate-500">Se attiva, chi visita il sito vede solo la pagina "In costruzione". Tu (admin), gli utenti già registrati e chi ha il link anteprima vedono il sito completo.</p>
          <p className={`mt-3 text-sm font-bold ${s.maintenance ? "text-[#FF6B00]" : "text-emerald-600"}`} data-testid="site-maintenance-status">
            {s.maintenance ? "Attiva: il sito è nascosto al pubblico" : "Disattivata: il sito è pubblico"}
          </p>
        </div>
        <Switch checked={s.maintenance} onCheckedChange={toggle} data-testid="site-maintenance-switch" />
      </div>
      <div className="rounded-2xl border border-slate-200 bg-white p-5 sm:p-6">
        <h3 className="font-display text-lg font-bold text-[#0B192C]">Link anteprima per tester</h3>
        <p className="mt-1 text-sm text-slate-500">Condividi questo link con le agenzie partner: aprendolo vedranno il sito completo e potranno registrarsi.</p>
        <div className="mt-3 rounded-xl bg-slate-50 border border-slate-200 px-3 py-2.5 text-sm font-mono break-all" data-testid="site-preview-link">{link}</div>
        <div className="mt-3 flex flex-wrap gap-2">
          <Button onClick={copy} className="rounded-full bg-[#142B5C]" data-testid="site-copy-link-btn"><Copy className="h-4 w-4 mr-2" />Copia link</Button>
          <Button onClick={newCode} variant="outline" className="rounded-full" data-testid="site-new-code-btn"><RefreshCw className="h-4 w-4 mr-2" />Genera nuovo link</Button>
        </div>
      </div>
    </div>
  );
}
